import React from "react";
import Product from "./Product";
import "./Home.css";

function Home() {
  console.log("Enter Home Page");
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/31/prime/Gaming/GW/1500x600-NP._CB432269252_.jpg"
          alt=""
        />
        <div className="home__row">
          <Product
            id="111111"
            title="Mi Smart Band 4- India's No.1 Fitness Band, Up-to 20 Days Battery Life, Color AMOLED Full-Touch Screen, Waterproof with Music Control and Unlimited Watch Faces"
            price={25}
            image="https://images-na.ssl-images-amazon.com/images/I/71ZSpNjEl0L._SL1500_.jpg"
            rating={5}
          />
          <Product
            id="222222"
            title="Apple iPhone 11 Pro Max (64GB) - Midnight Green 8 Gb ram 60 Fps A13 Bionic chip and amoled display"
            price={1200}
            image="https://images-na.ssl-images-amazon.com/images/I/61ers6OzvUL._SL1024_.jpg"
            rating={5}
          />
        </div>
        <div className="home__row">
          <Product
            id="444444"
            title="TBosch Aquatak 125 1.5-Watt High Pressure Washer (Green)"
            price={160}
            image="https://www.apple.com/in/home/heroes/watch-se/images/hero__dvsxv8smkkgi_small_2x.jpg"
            rating={4}
          />
          <Product
            id="555555"
            title="
Casio Youth-Combination Analog-Digital Gold Dial Men's Watch - AEQ-110BW-9AVDF (AD206)"
            price={50}
            image="https://images-na.ssl-images-amazon.com/images/I/81qr1wJv0cL._UL1500_.jpg"
            rating={5}
          />
        </div>
        <div className="home__row">
          <Product
            id="666666"
            title="Samsung 27 inch (68.6 cm) Curved Bezel Less LED Backlit Computer Monitor - Full HD, VA Panel with VGA, HDMI, Display, Audio in, Heaphone Ports - LC27F591FDWXXL (Silver)"
            price={2000}
            image="https://images-na.ssl-images-amazon.com/images/I/71Dwx3x6m9L._SL1500_.jpg"
            rating={5}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
